import { useTranslation } from '../../core/hooks/useTranslation'
import Modal from './Modal'

interface DeleteModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void | Promise<void>
  title?: string
  message?: string
  itemName?: string
  isLoading?: boolean
}

export default function DeleteModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  itemName,
  isLoading = false
}: DeleteModalProps) {
  const { t } = useTranslation()

  const defaultTitle = t('confirmDelete' as any) || 'Confirm Delete'
  const defaultMessage = itemName
    ? `${t('confirmDelete' as any) || 'Are you sure you want to delete'} "${itemName}"?`
    : t('confirmDeleteMessage' as any) || 'Are you sure you want to delete this item? This action cannot be undone.'

  const handleConfirm = async () => {
    await onConfirm()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title || defaultTitle}
      description={message || defaultMessage}
      actionButtonText={t('delete') || 'Delete'}
      onAction={handleConfirm}
      actionButtonLoading={isLoading}
      actionButtonDisabled={isLoading}
      actionButtonClassName="bg-red-600 text-white hover:bg-red-700 active:bg-red-800 text-sm h-9 py-2 px-4"
      showCancelButton={true}
      cancelButtonClassName="border-gray-300 text-[#1E293B] hover:text-[#1E293B] hover:border-[#1E293B] hover:bg-gray-50 text-sm h-9 py-2 px-3"
    >
      {null}
    </Modal>
  )
}

